import {
    IConfigFieldDefinition,
    ConfigFieldDefinitionBase
} from '../fields-definitions/config-field-definition-base';
import {ILauncherServiceFactory} from '../../launcher-service-factory.interface';

export function makeConfigurationArea<T>(rootPropName: string, services: ILauncherServiceFactory, area: T): T {
    setFieldsDependenciesRecursive(area, rootPropName, services);
    return area;
}


function setFieldsDependenciesRecursive(forObject: any, parentPath: string, services: ILauncherServiceFactory): void {
    Object.keys(forObject).forEach(propName => {
        let currentPath = parentPath ? parentPath + '.' + propName : propName;
        let propValue = forObject[propName];
        if(propValue instanceof ConfigFieldDefinitionBase) {
            let fieldDefinition = propValue as ConfigFieldDefinitionBase;
            fieldDefinition.injectDependencies({
                configurationKey: currentPath,
                services: services
            });
        } else {
            setFieldsDependenciesRecursive(propValue, currentPath, services);
        }
    });
}

export function extractConfigurationFields(configurationArea: object): IConfigFieldDefinition[] {
    return extractConfigurationAreaFieldsRecursive(configurationArea);
}

function extractConfigurationAreaFieldsRecursive(fromObject: any): IConfigFieldDefinition[] {
    let result: IConfigFieldDefinition[] = [];
    Object.keys(fromObject).forEach(propName => {
        let propValue = fromObject[propName];
        if(propValue instanceof ConfigFieldDefinitionBase) {
            result.push(propValue as IConfigFieldDefinition);
        } else {
            result = [...result, ...extractConfigurationAreaFieldsRecursive(propValue)];
        }
    });

    return result;
}

